export default __webpack_public_path__ + "assets/images/topik-negative.13e71b391f0b71404979a22a2f17cdb1.svg";